import { Stack } from "@mui/material";
import { useMemo, useState } from "react";
import Loading from "./components/Loading";
import LoadingContext from "./contexts/Loading";
import { RouterManager } from "./routes/RouterManager";

export const App = () => {
  const [isLoading, setIsLoading] = useState(false);
  const obj = useMemo(() => ({ isLoading, setIsLoading }), [isLoading]);
  return (
    <LoadingContext.Provider value={obj}>
      <Stack direction={"column"}>
        <RouterManager />
        <Loading />
      </Stack>
    </LoadingContext.Provider>
  );
};
